import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: 'input[dateInput]'
})
export class DateInputDirective {
  constructor(private _el: ElementRef, private control: NgControl) {}

  @HostListener('input', ['$event']) onInputChange() {
    const currentValue = this._el.nativeElement.value;
    const validInput = currentValue.replace(/[^0-9/]/g, ''); // Solo permite dígitos y /

    if (currentValue !== validInput) {
      this._el.nativeElement.value = validInput;
      this.control.control?.setValue(validInput);
    }
  }
}